import { Box, Grid, TextField, Button, Typography } from '@mui/material';

const SearchesTools = ({
    startDate, setStartDate,
    endDate, setEndDate,
    fetchStats
}) => {
    return (
        <Box sx={{ p: 2 }}>
            <Grid container spacing={2} alignItems="center" flexWrap="wrap" direction="row">
                <Typography variant="h6" sx={{ mr: 1, mt: 1 }}>
                    מה אנשים מחפשים
                </Typography>

                {/* תאריך התחלה */}
                <Grid item>
                    <TextField
                        label="מתאריך"
                        type="date"
                        size="small"
                        value={startDate}
                        onChange={e => setStartDate(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>

                {/* תאריך סיום */}
                <Grid item>
                    <TextField
                        label="עד תאריך"
                        type="date"
                        size="small"
                        value={endDate}
                        onChange={e => setEndDate(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>

                {/* כפתור טעינה */}
                <Grid item>
                    <Button variant="contained" size="small" onClick={fetchStats}>
                        טען
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
};

export default SearchesTools;
